import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useGenerateIds } from '../composables';
import type { FileUploadResult } from './blueimp-file-upload';


export default /*#__PURE__*/_defineComponent({
  __name: 'blueimp-file-upload-result',
  props: {
    hideDetails: { type: Boolean },
    hideClose: { type: Boolean },
    result: null
  },
  setup(__props: any) {

const props = __props as {
    hideDetails?: boolean;
    hideClose?: boolean;
    result?: FileUploadResult;
}

const generateIds = useGenerateIds();

//simulate old {% box %} macro, but only handle either both classes (horizontal) or none (vertical, inline)

const detailsId = generateIds();
const stats = computed(() => props.result?.stats ?? {});
const status = computed(() => {
    const stats0 = props.result?.stats;
    if(!stats0) return '';
    if(stats0.feerrors || stats0.fedenied || ((stats0.feimporting !== undefined) && (stats0.feimporting != stats0.feimported))) {
        return 'text-danger';
    } else if(stats0.feduplicates) {
        return 'text-warning';
    }
    return 'text-success';
});


return { __sfc: true,generateIds, props, detailsId, stats, status }
}

})